<template>
  <VoiceRightFormPanelNode />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
